import React from 'react'

type GroupProps = {
  left?: number
  top?: number
  transform?: string
}
const Group = React.forwardRef<
  SVGGElement,
  GroupProps & React.SVGProps<SVGGElement>
>(({ left = 0, top = 0, transform, ...rest }, ref) => {
  return (
    <g
      ref={ref}
      transform={transform || `translate(${left}, ${top})`}
      {...rest}
    />
  )
})

Group.displayName = 'Group'

export default Group
